var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-file-input',{attrs:{"show-size":"","label":"Файл"},on:{"change":_vm.fileChanged},model:{value:(_vm.file),callback:function ($$v) {_vm.file=$$v},expression:"file"}})}
var staticRenderFns = []

export { render, staticRenderFns }